import React from 'react'
import { Spin } from 'antd'

export const Spinner = (props) => {
  return <Spin size="large" {...props}></Spin>
}
